/* FULLHED cart drawer controller.
   Slide-in drawer opened by add-to-cart (no navigation): line items with shade
   and thumbnail, subscription labels, quantity controls, a free-shipping
   progress bar, a one-time -> subscribe nudge, and dataLayer events. */
(function () {
  var CFG = window.FH_CART || {};
  var track = window.fhTrack || function () {};
  var root = document.querySelector('[data-fh-drawer]');
  if (!root) return;

  var elItems = root.querySelector('[data-fh-items]');
  var elFoot = root.querySelector('[data-fh-foot]');
  var elEmpty = root.querySelector('[data-fh-empty]');
  var elCount = root.querySelector('[data-fh-drawer-count]');
  var elSubtotal = root.querySelector('[data-fh-subtotal]');
  var elCheckoutTotal = root.querySelector('[data-fh-checkout-total]');
  var elShip = root.querySelector('[data-fh-ship]');
  var elShipMsg = root.querySelector('[data-fh-ship-msg]');
  var elShipFill = root.querySelector('[data-fh-ship-fill]');
  var elNudge = root.querySelector('[data-fh-nudge]');

  function money(c) { return (CFG.moneyPrefix || 'A$') + (c / 100).toFixed(2); }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[m]; }); }

  function open() {
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    track('fh_drawer_open', {});
  }
  function close() {
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { root.hidden = true; }, 260);
  }

  root.querySelectorAll('[data-fh-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function change(key, qty) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function shippingBar(cart) {
    var threshold = CFG.threshold || 6000;
    var hasSub = cart.items.some(function (i) { return i.selling_plan_allocation; });
    var total = cart.total_price;
    var unlocked = hasSub || total >= threshold;
    elShip.hidden = false;
    if (unlocked) {
      elShipMsg.innerHTML = '<strong>Free shipping unlocked.</strong>' + (hasSub ? ' Subscriptions always ship free.' : '');
      elShipFill.style.width = '100%';
    } else {
      var away = threshold - total;
      elShipMsg.innerHTML = "You're <strong>" + money(away) + "</strong> away from free shipping.";
      elShipFill.style.width = Math.max(4, Math.round(total / threshold * 100)) + '%';
    }
  }

  function itemRow(it) {
    var img = it.image ? (it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120') : '';
    var subName = it.selling_plan_allocation ? String(it.selling_plan_allocation.selling_plan.name).replace(/,\s*A?\$[\d.,]+.*$/i, '').trim() : '';
    var sub = subName ? '<span class="fh-drawer__sublabel">' + esc(subName) + '</span>' : '';
    return '' +
      '<div class="fh-drawer__item" data-key="' + esc(it.key) + '">' +
        '<div class="fh-drawer__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" width="60" height="60">' : '') + '</div>' +
        '<div class="fh-drawer__info">' +
          '<div class="fh-drawer__name">' + esc(it.product_title) + '</div>' +
          (it.variant_title ? '<div class="fh-drawer__shade">Shade: ' + esc(it.variant_title) + '</div>' : '') +
          sub +
          '<div class="fh-drawer__qty">' +
            '<button type="button" class="fh-drawer__qbtn" data-act="dec" aria-label="Decrease">&minus;</button>' +
            '<span class="fh-drawer__qn">' + it.quantity + '</span>' +
            '<button type="button" class="fh-drawer__qbtn" data-act="inc" aria-label="Increase">+</button>' +
            '<button type="button" class="fh-drawer__remove" data-act="rm">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="fh-drawer__price">' + money(it.final_line_price) + '</div>' +
      '</div>';
  }

  function nudge(cart) {
    elNudge.innerHTML = '';
    if (sessionStorage.getItem('fh_nudge_dismissed')) return;
    if (!CFG.sellingPlanId) return;
    var hasSub = cart.items.some(function (i) { return i.selling_plan_allocation; });
    if (hasSub) return;
    var line = cart.items.filter(function (i) { return i.product_id === CFG.coreId && !i.selling_plan_allocation; })[0];
    if (!line) return;
    elNudge.innerHTML =
      '<div class="fh-drawer__nudgecard">' +
        '<button type="button" class="fh-drawer__nudgex" data-nudge-dismiss aria-label="Dismiss">&times;</button>' +
        '<div class="fh-drawer__nudgetitle">Switch to Subscribe &amp; save</div>' +
        '<p class="fh-drawer__nudgetext">A$39 per bottle and free shipping. Skip or cancel anytime.</p>' +
        '<button type="button" class="fh-drawer__nudgebtn" data-nudge-accept>Switch and save</button>' +
      '</div>';
    track('fh_upsell_shown', { where: 'drawer', variant_id: line.id });
    elNudge.querySelector('[data-nudge-dismiss]').addEventListener('click', function () {
      sessionStorage.setItem('fh_nudge_dismissed', '1'); elNudge.innerHTML = '';
    });
    elNudge.querySelector('[data-nudge-accept]').addEventListener('click', function () {
      var qty = line.quantity, vid = line.id;
      change(line.key, 0).then(function () {
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: qty, selling_plan: CFG.sellingPlanId }] })
        });
      }).then(function () {
        track('fh_upsell_accepted', { where: 'drawer', variant_id: vid });
        refresh();
      });
    });
  }

  function render(cart) {
    if (elCount) elCount.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    var badge = document.querySelector('[data-fh-cart-count]');
    if (badge) badge.textContent = cart.item_count;

    if (!cart.items.length) {
      elItems.innerHTML = ''; elFoot.hidden = true; elShip.hidden = true; elNudge.innerHTML = '';
      elEmpty.hidden = false;
      return;
    }
    elEmpty.hidden = true;
    elItems.innerHTML = cart.items.map(itemRow).join('');
    elFoot.hidden = false;
    elSubtotal.textContent = money(cart.total_price);
    elCheckoutTotal.textContent = money(cart.total_price);
    shippingBar(cart);
    nudge(cart);

    elItems.querySelectorAll('.fh-drawer__item').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      row.querySelector('[data-act="inc"]').addEventListener('click', function () { change(key, item.quantity + 1).then(render); });
      row.querySelector('[data-act="dec"]').addEventListener('click', function () { change(key, Math.max(0, item.quantity - 1)).then(render); });
      row.querySelector('[data-act="rm"]').addEventListener('click', function () { change(key, 0).then(render); });
    });
  }

  function refresh() { return getCart().then(render); }

  var checkoutBtn = root.querySelector('[data-fh-checkout]');
  if (checkoutBtn) checkoutBtn.addEventListener('click', function () {
    track('fh_begin_checkout', { where: 'drawer' });
    window.location.href = CFG.checkoutUrl || '/checkout';
  });

  // Public API used by the product add-to-cart flow
  window.fhCart = {
    open: function () { refresh().then(open); },
    close: close,
    refresh: refresh
  };

  // Any [data-fh-drawer-open] element (e.g. the header cart icon) opens the drawer
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-fh-drawer-open]');
    if (t) { e.preventDefault(); window.fhCart.open(); }
  });

  // If we're on the /cart page, open the drawer as the primary flow
  if (/\/cart\/?($|\?)/.test(window.location.pathname)) {
    window.fhCart.open();
  }
})();
